function ChecklistTasksCtrl($state, $auth, toaster, $stateParams, ClientChecklistService, CommonService, OrganizationService, $window, $timeout) {
    'ngInject';
  
    const vm = this;
    vm.loading= false;
    vm.user = $auth.user;
    vm.addChecklistFlag= false;
    vm.addChecklistForm = {};
    vm.addTaskForm = {};
    vm.taskLoading = false;
    vm.tasks = {};
    vm.taskArray = [];
    vm.taskId = !$stateParams.taskId ? '' : $stateParams.taskId;
    vm.checklistId = !$stateParams.checklistId ? '' : $stateParams.checklistId;
    vm.orgId = !$stateParams.orgId ? '' : $stateParams.orgId;
    vm.taskStatus = !$stateParams.task_status ? 'todo' : $stateParams.task_status;
    vm.taskStatus = vm.taskStatus == 'all' ? '' : vm.taskStatus;
    vm.parentId = null;
    vm.userAssign = {users: ''};
    vm.userAssignArray = [];
    vm.clientView = false;
    vm.currentPage = 1;
    vm.lazyLoading = false;
    vm.usersForEmails = [];
    vm.attachTaskId = '';
    vm.assignTaskId = '';
    vm.descriptionAttachment = [];

    angular.element($window).bind('scroll', function(e) {
      if(($state.current.name == 'user.organization.settingView.checklistTasks.default') || ($state.current.name == 'client.clientDashboard.tasks')){
        if($(window).scrollTop() + $(window).height() == $(document).height()) {
          vm.paginate();
        }
      }
    });
      
    vm.init = function () {
      if (!vm.user.role) {
        $auth.validateUser().then(function () {
          vm.user = $auth.user;
          vm.checkClient();
        });
      } else{
        vm.checkClient();
      }
      if (vm.taskId) {
        ClientChecklistService.getTaskDetails(vm.orgId, vm.taskId, function (response) {
          if(response.status >= 200 && response.status < 300){
            for (var key in response.data) {
              if (response.data.hasOwnProperty(key) && (response.data[key] == null || response.data[key] == undefined)) {
                response.data[key] = '';
              }
          }
          vm.addTaskForm = response.data;
          }
        });
      } else {
        vm.loading = true;
        vm.taskLoading = true;
        ClientChecklistService.getOrganizationTasks(vm.orgId, vm.taskStatus, vm.currentPage, function(response){
          vm.loading = false;
          if(response.status >= 200 && response.status < 300){
            vm.orgTasks = response.data.tasks;
            vm.childTasks = response.data.child_tasks;
            vm.tasks = {};
            vm.childTasks.forEach(task => {
              if(!vm.tasks[task.parent_id]){
                vm.tasks[task.parent_id] = [];
              }
              vm.tasks[task.parent_id].push(task) ;
            });
            vm.taskLoading = false;
          }
          OrganizationService.getAssignedUsers(vm.orgId, function (resp) {
            if (resp.status == 200) {
              vm.usersForEmails = resp.data.users.filter(function(u){ return (u.user_status && (u.email != $auth.user.email));});
            }
          });
        });
      }
    };

    vm.checkClient = function () {
      if (vm.user.role == 'client') {
        vm.welcomeFlag = $auth.user.welcome;
        vm.clientView = true;
      }
    };

    vm.uploadFiles = function(files, errFiles) {
      vm.attachments = files;
    };

    $(document).on("trix-attachment-add", function(event) {
      var addedFile = event.originalEvent.attachment.file;
      var attachment = event.originalEvent.attachment;
      if (addedFile) {
        CommonService.addDescriptionImage(addedFile, function (response) {
          let attributes = CommonService.getAttachmentAttributes(addedFile, response.data);
          
          attachment.setAttributes(attributes);
        });
      }
    });

    vm.editChecklist = function(id, $event){
      $event.preventDefault();
      $event.stopPropagation();
      $timeout(function(){
        $('#editable-'+ id).trigger('click');
      });
    };

    vm.welcomeClose = function () {
      ClientChecklistService.cancelWelcome(function (response) {
        if (response.status >= 200 & response.status < 300) {
          toaster.pop('info', 'Done');
          vm.welcomeFlag = false;
          $auth.user.welcome = false;
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
     };
  
    vm.getChildTasks = function (parentId) {
      vm.taskLoading = true;
      vm.tasks[parentId] = [];
      ClientChecklistService.getChildTasks(vm.orgId, parentId, function(response){
        if(response.status >= 200 && response.status < 300){
          vm.taskLoading = false;
          vm.taskArray = response.data.tasks;
          vm.tasks[parentId] = vm.taskArray;
        }
      });
    };

    vm.paginate = function () {
      if(!vm.lazyLoading){
        vm.lazyLoading = true;
        vm.lazyLoading = false;
        vm.currentPage = vm.currentPage + 1;
        ClientChecklistService.getOrganizationTasks(vm.orgId,  vm.taskStatus, vm.currentPage, function (response) {
        vm.loading = false;
        if (response.status >= 200 && response.status < 300) {
          if(vm.currentPage == response.data.pagination.current_page){
             if(response.data.tasks.length <= 0){
              vm.currentPage = vm.currentPage - 1;
             } else {
             vm.tasks = vm.tasks.concat(response.data.tasks);
             }
          } 
        }
      });
      }
    };

    vm.taskDirectiveCallback = function(type, data){
      switch(type) {
        case 'edit':
          vm.editTask(data.taskId, data.parentId);
        break;
        case 'delete':
          vm.deleteChecklistAndTask(data.taskId, data.parentId);
        break;
        case 'deleteAttachment':
          vm.removeAttachment(data.taskId, data.attachmentId, data.parentId);
        break;
        case 'updateStatus':
          vm.completeTask(data.taskId, data.parentId, data.taskStatus);
        break;
        case 'assignTaskView':
          vm.assginTaskView(data.taskId);
        break;
        case 'addAttachmentView':
          vm.attachTaskView(data.taskId);
        break;
        case 'rearrangeTask':
          vm.rearrangeTask(data.taskId, data.position, data.parentId);
        break;
        default:
      }
    };

    vm.attachTaskView = function (taskId) {
      vm.attachTaskId = taskId;
      vm.attachments = [];
      $('#addAttachmentModal').modal('show');
    };

    vm.addAttachment = function(){
      let data = vm.attachmentForm.url;
      ClientChecklistService.addAttachment(vm.orgId, vm.attachTaskId, data, function (response) {
        if(response.status >= 200 && response.status < 300){
          toaster.pop('info', 'Attachments uploaded successfully.');
          $('#addAttachmentModal').modal('hide');
          vm.init();
        } else {
          vm.taskLoading = false;
          toaster.pop('error', CommonService.throwError(response));
          vm.attachments = [];
        }
      });
    };
  
    vm.addNewChecklist = function () {
      vm.addChecklistFlag = true;
    };
  
    vm.addTask = function (parentId) {
      $state.go('user.organization.settingView.checklistTasks.taskNew', {orgId: vm.orgId, checklistId: parentId}, {inherit: false});
    };
  
    vm.addStandaloneTask = function () {
      $state.go('user.organization.settingView.checklistTasks.standaloneTask', {inherit: false});
    };
  
    vm.saveChecklist = function () {
      vm.submitted = true;
      ClientChecklistService.newChecklist(vm.orgId, vm.addChecklistForm, function (response) {
        if(response.status >= 200 && response.status < 300){
          vm.addChecklistFlag = false;
          toaster.pop('info', 'Checklist added successfully.');
          vm.init();
        }
      });
    };

    vm.inlineEditValidate = function (data) {
      if(!data){
        return "Checklist title cannot be empty";
      }
    };
  
    vm.inlineSave = function (checklist) {
      let updateData = { title: checklist.title };
      ClientChecklistService.updateChecklistAndTask(vm.orgId, checklist.id, updateData, function (response) {
        if(response.status >=200 && response.status <300){
          toaster.pop('info', 'Checklist updated successfully.');
        }
      });
    };
  
    vm.saveTask = function () {
      vm.submitted = true;
      vm.taskLoading = true;
      if (vm.taskId) {
        ClientChecklistService.updateChecklistAndTask(vm.orgId, vm.taskId, ClientChecklistService.formParams(vm.addTaskForm, vm.checklistId), function (response) {
          if (response.status >= 200 && response.status < 300) {
            vm.taskLoading = false;
            toaster.pop('info', 'Task updated successfully.');
            $state.go('user.organization.settingView.checklistTasks.default', { inherit: false });
          } else {
            vm.taskLoading = false;
            toaster.pop('error', CommonService.throwError(response));
            vm.attachments = [];
          }
        });
      } else {
        ClientChecklistService.newTask(vm.orgId, ClientChecklistService.formParams(vm.addTaskForm, vm.checklistId), function (response) {
          if (response.status >= 200 && response.status < 300) {
            vm.taskLoading = false;
            toaster.pop('info', 'Task saved successfully.');
            $state.go('user.organization.settingView.checklistTasks.default', { inherit: false });
          } else {
            vm.taskLoading = false;
            toaster.pop('error', CommonService.throwError(response));
            vm.attachments = [];          
          }
        });
      }
    };
  
    vm.cancelBtn = function () {
      vm.addChecklistFlag = false;
      vm.addTaskForm = {};
      $state.go('user.organization.settingView.checklistTasks.default', {inherit: false});
    };
  
    vm.editTask = function (taskId, parentId) {
      if(parentId != taskId){
      $state.go('user.organization.settingView.checklistTasks.taskNew', {orgId: vm.orgId, taskId: taskId, checklistId: parentId}, {inherit: false});
      } else{
      $state.go('user.organization.settingView.checklistTasks.standaloneTask', {orgId: vm.orgId, taskId: taskId }, {inherit: false});
      }
    };
  
    vm.deleteChecklistAndTask = function (taskId, parentId) {
      swal({
        title: 'Are you sure?',
        text: 'Are you sure to delete this task.',
        icon: 'warning',
        dangerMode: true,
        buttons: [true, true],
      })
      .then(willDelete => {
        if (willDelete) {
          ClientChecklistService.deleteChecklistAndTask(vm.orgId, taskId, function (response) {
            if (response.status >= 200 && response.status < 300) {
              toaster.pop('info', 'Task deleted successfully.');
              if (parentId) {
                vm.getChildTasks(parentId);
              }
              vm.init();
            } else {
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        }
      });
    };

    vm.removeAttachment = function( taskId, attachmentId, parentId){
      swal({
        title: 'Are you sure?',
        text: 'Attachment will be removed.',
        icon: 'warning',
        dangerMode: true,
        buttons: [true, true],
      })
      .then(willDelete => {
        if (willDelete) {
          ClientChecklistService.removeAttachment(vm.orgId, taskId, attachmentId,  function (response) {
            if (response.status >= 200 && response.status < 300) {
              toaster.pop('info', 'Attachment removed.');
              if (parentId == null){
                vm.init();
              } else {
              vm.getChildTasks(parentId);
              }
            } else {
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        }
      });
    };

    vm.updateUserListByEmail = function (email) {
      if (email.length >= 0) {
        OrganizationService.getAssignedUsers(vm.orgId, function (response) {
          if (response.status == 200) {
            vm.users = response.data.users;
            vm.usersForEmails = vm.users.filter(function(u){ return u.user_status;});
          }
        });
      }
    };

    vm.assginTaskView = function (taskId) {
      vm.assignTaskId = taskId;
      vm.userAssign = {users: ''};
      $('#assignModal').modal('show');
    };

    vm.assignTask = function () {
      let assignee= [vm.userAssign.users.id];
        ClientChecklistService.assignTaskToUser(vm.orgId, vm.assignTaskId, assignee, function (resp) {
          if (resp.status >=200 && resp.status <300) {
            toaster.pop('info', 'Successfully assigned task to the user.');
          } else {
            toaster.pop('error', CommonService.throwError(resp));
          }
          $('#assignModal').modal('hide');
          vm.init();
        });
    };

    vm.closeAssignForm = function () {
      vm.assignTaskFlag = false;
    };

  vm.completeTask = function (taskId, parentId, status) {
    let taskStatus = status ? 'complete' : 'todo';
    swal({
      title: 'Are you sure?',
      text: 'Status will be changed to ' + taskStatus,
      icon: 'success',
      buttons: [true, true],
    })
      .then(taskComplete => {
        if (taskComplete) {
          ClientChecklistService.completeTask(vm.orgId, taskId, { 'task_status': taskStatus }, function (resp) {
            if (resp.status >= 200 && resp.status < 300) {
              toaster.pop('info', 'Successfully updated task to ' + taskStatus +' status.');
              if(taskId == parentId){
                vm.orgTasks.filter(x => x.id == taskId )[0]['task_status'] = taskStatus;
              }else{
                vm.getChildTasks(parentId);
              }
            } else {
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        }else{
          if(taskId == parentId){
            angular.element($('#ytd' + taskId)).prop("checked", !status);
          } else {
            vm.getChildTasks(parentId);
          }
        }
      });
  };

  vm.filterTasks = function (params) {
    $state.go($state.current.name, { orgId: vm.orgId, task_status: params }, {inherit: false});
  };

  vm.rearrangeTask = function (taskId, position, parentId) {
    ClientChecklistService.rearrangeTask(vm.orgId, taskId, position, function (response) {
      if(response.status >= 200 && response.status < 300){
        toaster.pop('info', 'Tasks successfully rearranged.');
      } else {
        toaster.pop('error', CommonService.throwError(response));
        vm.getChildTasks(parentId);
      }
    });
  };
}
export default {
  name: 'ChecklistTasksCtrl',
  fn: ChecklistTasksCtrl
};